import { SupportService } from '@acme/api/client';
import type { CreateTicketModel } from '@acme/domains';
import { CreateTicketForm } from '@acme/features';
import { Breadcrumb, type BreadcrumbItem } from '@acme/foundation';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { $applications, $categories, $isLoading, pageOpened } from '../model';

export const TicketsCreatePage = () => {
  const navigate = useNavigate();
  const { applications, categories, isLoading, onPageOpened } = useUnit({
    applications: $applications,
    categories: $categories,
    isLoading: $isLoading,
    onPageOpened: pageOpened,
  });

  useEffect(() => {
    onPageOpened();
  }, [onPageOpened]);

  const createTicket: CreateTicketModel = async (data) => {
    const response = await SupportService.postApiV1SupportTicketCreate({
      formData: {
        categoryId: data.categoryId,
        subject: data.subject,
        message: data.message,
        applicationId: data.applicationId,
        files: data.files,
      },
    });
    return response;
  };

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: 'Центр помощи',
      onClick: () => navigate('/help'),
    },
    {
      label: 'Мои обращения',
      onClick: () => navigate('/help/tickets'),
    },
    {
      label: 'Новое обращение',
    },
  ];

  const handleSuccess = () => {
    navigate(`/help/`);
  };

  return (
    <div className="flex flex-col gap-6 p-6 max-w-7xl mx-auto">
      <Breadcrumb items={breadcrumbItems} />

      {!isLoading && (
        <CreateTicketForm
          categories={categories}
          applications={applications}
          createTicket={createTicket}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
};
